import Vue from 'vue'

import VModal from 'vue-js-modal/dist/index.nocss.js'

Vue.use(VModal)
